"use client";

import ErrorResultCard from "@/components/ErrorResultCard";

// 영문(/en) 라우트의 에러 바운더리 — 루트 error.tsx 의 영문 미러.
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorResultCard locale="en" error={error} reset={reset} />;
}
